export default __webpack_public_path__ + "static/media/icon-none.1d8769bd.svg";